import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Route,
  UrlSegment,
} from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of, switchMap } from 'rxjs';
import { AuthService } from '../auth.service';
import { Injectable } from '@angular/core';
import { UTILS } from '../../const/const';
import { User } from '../../user/user.type';

@Injectable({
  providedIn: 'root',
})
export class NoAuthGuard {
  /**
   * Constructor
   */
  constructor(
    private _authService: AuthService,
    private _router: Router,
    private _cookies: CookieService
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Can activate
   *
   * @param route
   * @param state
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this._check();
  }

  /**
   * Can activate child
   *
   * @param childRoute
   * @param state
   */
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this._check();
  }

  /**
   * Can load
   *
   * @param route
   * @param segments
   */
  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this._check();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Check the authenticated status
   *
   * @private
   */
  private _check(): Observable<boolean> {
    // Check the authentication status
    // check some condition
    let userConnected = <User|any>(this._cookies.get('user') || localStorage.getItem('user'));
    if (userConnected) {
      userConnected = typeof userConnected === 'string' ? JSON.parse(userConnected) : userConnected;
      let regpdValidExpired = false;

      let redirectTo =
        '/espace-personnel/' +
        UTILS.replaceSpace(userConnected.username) +
        '/tableau-de-bord';

      // if (
      //   (userConnected.rgpdvalide == null || regpdValidExpired) &&
      //   userConnected.type.id != 5 &&
      //   userConnected.type.id != 9
      // ) {
      //   redirectTo =
      //     '/espace-personnel/' +
      //     UTILS.replaceSpace(userConnected.username) +
      //     '/mes-informations';
      // } else
      if (userConnected.type.id == 9) {
        if (userConnected.first_attempt)
          redirectTo =
            '/espace-personnel/' +
            UTILS.replaceSpace(userConnected.username) +
            '/mes-informations';
        else
          redirectTo =
            '/espace-personnel/' +
            UTILS.replaceSpace(userConnected.username) +
            '/tableau-de-bord';
      }
      if (userConnected.type.id == 5) {
        redirectTo =
          '/espace-personnel/' +
          UTILS.replaceSpace(userConnected.username) +
          '/tableau-de-bord';
      }
      // Redirect to the root
      void this._router.navigateByUrl(redirectTo);

      // Prevent the access
      return of(false);
    }
    return of(true);
  }
}
